<script setup lang="ts">
import { computed } from 'vue'
import { REGULATION_STATUS } from '@/constants/regulationStatus'

const props = defineProps<{ params: { data?: { status?: string } } }>()

const statusLabels: Record<string, string> = {
  [REGULATION_STATUS.WAITING]: 'En attente',
  [REGULATION_STATUS.VALIDATED]: 'Validée',
  [REGULATION_STATUS.CANCELED]: 'Annulée',
}

const statusLabel = computed(() => {
  const s = props.params?.data?.status
  return s ? (statusLabels[s] ?? s) : '-'
})
</script>

<template>
  <span
    :class="{
      'badge bg-amber-100 text-amber-800': params?.data?.status === REGULATION_STATUS.WAITING,
      'badge bg-emerald-100 text-emerald-800': params?.data?.status === REGULATION_STATUS.VALIDATED,
      'badge bg-neutral-200 text-neutral-600': params?.data?.status === REGULATION_STATUS.CANCELED,
    }"
  >
    {{ statusLabel }}
  </span>
</template>
